import { DestinationItemType } from '@tableau/nested-project-explorer/lib/src/DestinationItem';

import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { getAppStore } from '~src/app/AppStore';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { IError } from '~src/httpClient/serverApi/types/IError';

import { DatasourceContentType } from '../../spacesPlatform/models/ContentTypes';
import { CommonErrorCode, ContentErrorCode, DatasourceErrorCode, TagErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { IDataSourceBase } from '../models/IDataSourceInfo';

export namespace DataSourceErrors {
  export function errorDetailsFor(datasourceErrorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: datasourceErrorItem.item.name,
      itemUrl:
        datasourceErrorItem.error.code === CommonErrorCode.DatasourceNotFound
        || datasourceErrorItem.error.code === CommonErrorCode.DataConnectionNotFound
          ? null
          : ContentUrlForItem(datasourceErrorItem.item, DatasourceContentType),
      errorMessage: this.errorMessageFor(datasourceErrorItem.error, datasourceErrorItem.item.name)
    };
  }

  export function errorMessageFor(error: IError, datasourceName: string = '') {

    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
      case CommonErrorCode.DataConnectionNotFound:
        return Messages.errorDatasourceNotFound({DATASOURCE_NAME: L10n.elideIfLong(datasourceName)});
      case DatasourceErrorCode.DatasourceChangeOwnerDisabled:
        return Messages.errorDatasourceChangeOwnerDisabled();

      // Permissions errors
      // TODO: Do we want specific error messages for each of these cases?
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDatasource:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDestinationProject:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnSourceProject:
        return Messages.errorDatasourceMoveInsufficientPermissions();
      case DatasourceErrorCode.DatasourceWithSameNameInDestinationProject:
        return Messages.errorDatasourceWithSameNameInDestinationProject();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorDatasourceInsufficientPermissions();
      case TagErrorCode.TooManyTags:
        return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
      case DatasourceErrorCode.DatasourceChangeOwnerNotAllowedInPersonalSpace:
        return Messages.changeOwnerContentItems_notAllowedInPersonalSpaceError();
      default:
        return Messages.errorUnknown();
    }
  }

  export function moveContentToContainerErrorMessageDetailsFor(datasourceErrorItem: IErrorItem<IDataSourceBase>, destinationType: DestinationItemType): IErrorDetail {
    return {
      itemName: datasourceErrorItem.item.name,
      itemUrl:
        datasourceErrorItem.error.code === CommonErrorCode.DatasourceNotFound
        || datasourceErrorItem.error.code === CommonErrorCode.DataConnectionNotFound
          ? null
          : ContentUrlForItem(datasourceErrorItem.item, DatasourceContentType),
      errorMessage: this.moveContentToContainerErrorMessageFor(datasourceErrorItem.error, destinationType, datasourceErrorItem.item.name)
    };
  }

  export function moveContentToContainerErrorMessageFor(error: IError, destinationType: DestinationItemType, datasourceName: string = '') {

    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
      case CommonErrorCode.DataConnectionNotFound:
        return Messages.errorDatasourceNotFound({DATASOURCE_NAME: L10n.elideIfLong(datasourceName)});

      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDatasource:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDestinationProject:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnSourceProject:
      case CommonErrorCode.MoveInsufficientPermissionsOnContent:
        return Messages.errorDatasourceMoveInsufficientPermissions();
      case DatasourceErrorCode.DatasourceWithSameNameInDestinationProject:
        return destinationType === DestinationItemType.personalSpace ?
          Messages.errorDatasourceWithSameNameInPersonalSpace() :
          Messages.errorDatasourceWithSameNameInDestinationProject();
      case CommonErrorCode.CallingUserInsufficientPermissions:
          return Messages.errorDatasourceInsufficientPermissions();
      case ContentErrorCode.INVALID_CONTENT_TYPE:
          return Messages.moveContentToPersonalSpaceErrorDetail({CONTENT_TYPE: Messages.datasources()});
      default:
        return Messages.errorUnknown();
    }
  }
}
